import removeNumberSeparators, { getDecimalSeparator } from './removeNumberSeparators';
var localDecimalSeparator = getDecimalSeparator();
var numberDecimalSeparator = Number.isNaN(Number('1.1')) ? ',' : '.';
export default function convertLocaleStringToNumber(value) {
  return Number(removeNumberSeparators(value).replace(localDecimalSeparator, numberDecimalSeparator));
}